
define(function(){
	const ASSIGNMENT_TYPES_DESCRIPTION_MAX_DISPLAY_LENGTH = 50;
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	const builder = require('civicsUtils/buildUrlParameters');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IpsModelCollection.extend({
    urlRoot: '/delegate/civics-api/api/core/views/assignmentsubtypes',
		url: function() {
			if(AvailableFeatures.TypeFilterStoredProcedure() && this.isInMyAssignmentCardView){
				return '/delegate/civics-api/api/portal/myassignmenttypes';
			}else{
				var parameters = '';
				if (this.urlParameters != undefined) {
					parameters = builder.buildUrlParameters(this.urlParameters);
				}
				if (parameters.indexOf('?') >= 0) {
					parameters += '&Page=[{Max:0}]';
				} else {
					parameters += '?Page=[{Max:0}]';
				}
				return this.urlRoot + parameters;
			}
		},
    parse: function(response) {
			var data = response.data ? response.data : [];
			var dataNew = {};
			for (i = 0; i < data.length; i++) {
				dataNew = data[i];
		    var computedDescription =
		        Handlebars.helpers['global:computedDescription'](dataNew.portalDescription, dataNew.typeDescription);
		    dataNew.computedDescription = computedDescription;
		    dataNew.computedDescriptionShort =
		        Handlebars.helpers['global:limitLength'](computedDescription, ASSIGNMENT_TYPES_DESCRIPTION_MAX_DISPLAY_LENGTH);

				dataNew.value = dataNew['portalDescription'];
				dataNew.displayName = dataNew['computedDescriptionShort'];
				dataNew.propertyName = 'portalDescription';
				dataNew.description = dataNew['typeDescription'];
				dataNew.portalDescription = dataNew['portalDescription'];
				dataNew.completeDescription = dataNew['computedDescription'];

				data[i] = dataNew;
			}
			data = _.uniq(data, function (e) {
				return e.value;
			});
			data.sort(function(val1,val2) {
				var a = val1 || '';
				var b = val2 || '';
				if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) {
					return 1;
				}
				if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
					return - 1;
				}
				return 0;
			});
			return data;
		}
  });

});
